/**
 * key in the product image collection
 * @deprecated use AppImages settings from theme config instead
 */
export const PRODUCT_SLIDER_IMAGE_COLLECTION_KEY = 'PRODUCT_SLIDER_IMAGES';

/**
 * themes value for the product slider image formats
 * @deprecated use AppImages settings from theme config instead
 */
export const PRODUCT_SLIDER_IMAGE_FORMATS = [
  {
    width: 440,
    height: 440,
  },
  {
    width: 1024,
    height: 1024,
  },
];
